import React, { useState } from "react";
import { Button, IconButton } from "@mui/material";
import useSnackbar from "../../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../../Component/DigitalMarketing/Toast";
import { TestOrderInputs } from "./Utils/TestOrderInputs";
import { IoCloseCircleOutline } from "react-icons/io5";

interface MyLabsDetailsProps {
  updateData?: {
    id?: string;
    procedureTitle?: string;
    price?: string;
    gst?: string;
    notes?: string;
    instruction?: string;
    branchId?: string;
  };
  view: boolean;
  setShow: (show: boolean) => void;
}

const ViewTestOrders: React.FC<MyLabsDetailsProps> = (props) => {
  const { updateData, view, setShow } = props;
  const { open, message, openSnackBar, type } = useSnackbar();

  const [formData, setFormData] = useState({ ...updateData });

  const [submit, setSubmit] = useState(false);

  const handleChangeInfo = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setSubmit(true);
    const requiredFields = ["procedureTitle", "price", "gst", "branchId"];
    const missingFields = Object.entries(formData).filter(
      ([key, value]) => requiredFields.includes(key) && !value
    );

    if (missingFields.length > 0) {
      openSnackBar("Fill required data", "error");
      return;
    }

    openSnackBar("Form submitted successfully");
    setTimeout(() => {
      setShow(false);
    }, 350);
  };

  return (
    <div style={{ position: "relative" }}>
      <Toast open={open} type={type} message={message} />

      <div className="mt-3">
        <span className="f-18 fw-700">
          {view
            ? "Test Orders"
            : updateData?.id
            ? "Edit Procedure"
            : "Test Order Details"}
        </span>
      </div>

      {TestOrderInputs.map((a, i) => (
        <div className="input-custom mt-2" key={i}>
          <a.tag
            img={a.img}
            label={a.label}
            name={a.name}
            value={formData[a.key]}
            handleChange={handleChangeInfo}
            validation={a.validation}
            keyName={a.key}
            submit={submit}
            disabled={view}
          />
        </div>
      ))}
    </div>
  );
};

export default ViewTestOrders;
